import React, { useState } from 'react'


import {connect} from 'react-redux'
import { saveDetails } from './actions/index.js';




function UserForm(props) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const [country, setCountry] = useState("");

    const HandleSubmission = () => {

        const data = {
            firstname:firstName,
            lastname: lastName,
            address1: address1,
            address2: address2,
            city: city,
            state: state,
            zip: zip,
            country: country,
        }
        props.saveFormDataHandler(data);
        props.onSubmissionHandler();
    }


    
    const resetFields = () => {
        setFirstName("")
        setLastName("")
        setAddress1("")
        setAddress2("")
        setCity("")
        setState("")
        setZip("")
        setCountry("")
    }
  return ( 
    <div>

        <h1 id="userAddress">User Address</h1>

        <label>First Name</label>
        <input type='text' id="firstName" value={firstName} onChange={e => setFirstName(e.target.value)} /> <br/>

        
        <label>Last Name</label>
        <input type='text' id="lastName" value={lastName} onChange={e => setLastName(e.target.value)} /> <br/>

        
        <label>Address1</label>
        <input type='text' id="address1" value={address1} onChange={e => setAddress1(e.target.value)} /> <br/>

        
        <label>Address2</label>
        <input type='text' id="address2" value={address2} onChange={e => setAddress2(e.target.value)} /> <br/>

        
        <label>City</label>
        <input type='text' id="city" value={city} onChange={e => setCity(e.target.value)} /> <br/>

        
        <label>State</label>
        <input type='text' id="state" value={state} onChange={e => setState(e.target.value)} /> <br/>

        
        <label>Zip</label>
        <input type='text' id="zip" value={zip} onChange={e => setZip(e.target.value)} /> <br/>

        
        <label>Country</label>
        <input type='text' id="country" value={country} onChange={e => setCountry(e.target.value)} /> <br/>


        <button id='button' onClick={() => HandleSubmission()}>Submit</button>
        <button id='cancelButton' onClick={() => resetFields()}>Cancel</button>




    </div>
  )
}


const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
    saveFormDataHandler:data=>dispatch(saveDetails(data)),
})

export default connect(mapStateToProps,mapDispatchToProps)(UserForm)


